<div class="ils-login">
  <div class="title-bar">
    <app-title-bar></app-title-bar>
  </div>
  <div class="login-part">
    @if (ilsDescription?.description) {
      <div [innerHTML]="ilsDescription?.description | sanitizeHtml"
           class="ils-description">
      </div>
    }
    @if (ilsDescription?.learningAnalyticsEnabled && !previewMode) {
      <div class="learning-analytics-enabled">
          <span>
            {{ 'login.learningAnalyticsEnabled' | translate }}
          </span>
      </div>
    }
    <div class="nickname">
      <div>
        {{ 'login.enterNickname' | translate }}
      </div>
      <div class="nickname-entry">
        <input
          #nicknameInput
          (keydown)="this.enterClicked($event)"
          [(ngModel)]="nickname"
          [placeholder]="'login.nickname' | translate"
          autocomplete="new-password"
          name="playerNickname"
          id="playerNickname"
          type="text"
        />
        <button
          (click)="loginClicked()"
          [disabled]="!validNickname()"
          [matTooltip]="'login.login' | translate"
          mat-icon-button
          type="submit"
        >
          <mat-icon>login</mat-icon>
        </button>
      </div>
    </div>
    @if (previewMode) {
      <div class="preview-mode">
        <div class="preview-warning">
          <mat-icon>warning_amber</mat-icon>
          <span>{{ 'login.published.warning' | translate }}</span>
        </div>
        <div>
          {{ 'login.published.question' | translate }}
        </div>
        <div>
          {{ 'login.published.explanation' | translate }}
        </div>
        <div>
          {{ 'login.published.how' | translate }}
        </div>
      </div>
    }
  </div>
</div>
